/* AT2 EXPERIMENT - Analysis Modal */

/**
 * 🟤 Step 3: Modal "Analyse AT2 en cours..."
 *
 * Affichée pendant l'analyse du message de l'agent.
 * Modal non fermable avec spinner de chargement.
 */

import { Box, Typography } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

import { AT2AnalysisLoader } from './shared/AT2AnalysisLoader';
import { AT2GradientModalDialog } from './shared/AT2GradientModalDialog';

type Props = {
    open: boolean;
};

export function AT2_AnalysisModal({ open }: Props) {
    const { formatMessage } = useIntl();

    return (
        <AT2GradientModalDialog open={open}>
            <Typography variant="h4" color="white" align="left" sx={{ width: '100%', mb: 5 }}>
                {formatMessage({ id: 'dossier.discussion.at2.modal.analysis.title' })}
            </Typography>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="center"
                gap={2}
                sx={{ width: '100%', px: 6, mb: 8 }}
            >
                <Typography variant="h5" color="white" align="left" sx={{ width: '100%' }}>
                    {formatMessage({ id: 'dossier.discussion.at2.modal.analysis.checking' })}
                </Typography>
                <AT2AnalysisLoader sx={{ width: '100%' }} />
                <AT2AnalysisLoader sx={{ width: '80%' }} />
                <AT2AnalysisLoader sx={{ width: '60%' }} />
            </Box>
        </AT2GradientModalDialog>
    );
}
